import { Size } from './types';

export const isMobile = ({ width }: Size) => width < 480;
export const isTablet = ({ width }: Size) => width >= 480 && width < 1024;
export const isDesktop = ({ width }: Size) => width >= 1024;
